<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text>
                    <!-- <div class="fs-16 font_weight_600 mb-3 black--text">
                      Informasi Personal
                    </div> -->
                    <v-row>
                      <v-col cols="12" md="5" class="pb-0 pr-0">
                        <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Nama Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.school_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Nama Pegawai
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              NIK
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.nik }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Jenis Kelamin
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.gender }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Tempat Tanggal Lahir
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.tempat_lahir }}, {{ form.tgl_lahir_date | date }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Email
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.email }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 170px; min-width: 170px; max-width: 170px;" class="black--text">
                              Nomor Telepon
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              +62 {{ form.mobile_phone_number }}
                            </td>
                          </tr>

                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nomor Kepegawaian
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.nip }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Status Kepegawaian
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.status }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Pangkat / Golongan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.golongan }}
                            </td>
                          </tr>
                        </table>
                      </v-col>
                      <v-col cols="12" md="7" class="pb-0 pr-0">
                        <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Jenjang Pendidikan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Nama Jurusan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education_jurusan }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Nama Instansi
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education_instansi }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Tanggal Mulai Pendidikan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education_start_date | date }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Tanggal Selesai Pendidikan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education_end_date | date }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Nilai Akhir
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.education_nilai_akhir }}
                            </td>
                          </tr>

                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 240px; min-width: 240px; max-width: 240px;" class="black--text">
                              Lampiran Pendidikan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              <a :href="form.education_lampiran_url" target="_blank">{{ form.education_lampiran_url.split('/')[6] }}</a>
                            </td>
                          </tr>


                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Jabatan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.jabatan_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Jabatan Terhitung Mulai Tanggal
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.jabatan_tmt | date }}
                            </td>
                          </tr>
                          <!-- <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Hak Akses
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.category_name === '' || form.category_name === null ? '-' : form.category_name }}
                            </td>
                          </tr> -->
                        </table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card flat class="mt-5"
                  style="border-radius: 6px;">
                  <v-card-text>
                    <div class="fs-13 font_weight_600 mb-2 black--text">
                      Data Alamat
                    </div>
                    <div  class="black--text fs-13 px-1 mb-2 font_weight_600">
                      {{ form.address === '' || form.address === null ? '-' : form.address }}, RT/RW {{ form.rt_rw === '' || form.rt_rw === null ? '-' : form.rt_rw }}, Kelurahan {{ form.village_name }}, Kecamatan {{ form.subdistrict_name }}, Kota / Kabupaten {{ form.city_name }}, Provinsi {{ form.province_name }}
                    </div>

                    <v-divider class="mt-2 mb-3"></v-divider>

                    <div
                      class="" v-if="!process.load">
  
                      <gmap-map
                        :center="center"
                        :zoom="12"
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: true,
                          disableDefaultUi: false
                        }"
                        :clickable="false"
                        style="width: 100%; height: 320px;">
  
                        <gmap-marker
                          :position="center"
                          :draggable="false">
                        </gmap-marker>
                      </gmap-map>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- <v-card 
                  flat
                  style="border-radius: 6px;" class="mt-5">
                  <v-card-text>
                    <div class="fs-16 font_weight_600 mb-3 black--text">
                      Informasi Pendidikan
                    </div>
                    <table style="border: none; width: 100%; border-collapse: collapse;">
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Jenjang Pendidikan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Nama Jurusan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education_jurusan }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Nama Instansi
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education_instansi }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Tanggal Mulai Pendidikan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education_start_date | date }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Tanggal Selesai Pendidikan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education_end_date | date }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Nilai Akhir
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.education_nilai_akhir }}
                        </td>
                      </tr>

                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Lampiran
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          <a :href="form.education_lampiran_url" target="_blank">{{ form.education_lampiran_url }}</a>
                        </td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card> -->
                <v-card 
                  flat
                  style="border-radius: 6px;" class="mt-5">
                  <v-card-text>
                    <!-- <div class="fs-16 font_weight_600 mb-3 black--text">
                      Informasi Pekerjaan
                    </div>
                    <table style="border: none; width: 100%; border-collapse: collapse;">
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Nomor Kepegawaian
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.nip }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Status Kepegawaian
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.status }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Pangkat / Golongan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.golongan }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Jabatan
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.jabatan_name }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Jabatan Terhitung Mulai Tanggal
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.jabatan_tmt | date }}
                        </td>
                      </tr>
                      <tr>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                          Hak Akses
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                          :
                        </td>
                        <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                          {{ form.category_name }}
                        </td>
                      </tr>
                    </table> -->

                    <div class="mb-0 font_weight_600 fs-14 black_one mb-2 px-3">
                      Dokumen Lampiran Pekerjaan
                    </div> 
                    <div class="px-3">
                      <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                        <tr>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                            Link
                          </th>
                          <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                            Nama Dokumen
                          </th>
                        </tr>
                        <tr v-for="(item, index) in form.lampiran_json" :key="index">
                          <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :href="item.url"
                                  target="_blank"
                                  
                                  v-bind="attrs"
                                  v-on="on"
                                  
                                  min-width="24" min-height="24"
                                  x-small
                                  rounded
                                  :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                </v-btn>
                              </template>

                              <span>Lihat</span>
                            </v-tooltip>
                          </td>
                          <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                            {{ item.title }}
                          </td>
                        </tr>
                      </table>

                      <v-card-text
                        v-if="form.lampiran_json.length === 0"
                        class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                        <div class="text-center">
                          <div class="mt-3 fs-16">
                            Belum ada data
                          </div>
                        </div>
                      </v-card-text>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-spacer/>
  
                    <v-btn
                      to="/manajemen-akademik/data-pengguna/data-guru-pegawai"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Kembali
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          step_index: 1,
          form: {
            id: '',
            school_id: '',
            category_id: '',
            nip: '',
            name: '',
            email: '',
            gender: '',
            tempat_lahir: '',
            tgl_lahir_date: '',
            jabatan_id: '',
            jabatan_name: '',
            golongan: '',
            image_url:'',
            mobile_phone_number: '',
            jabatan_tmt: '',

            nik: '',
            province_id: '',
            city_id: '',
            subdistrict_id: '',
            province_name: '',
            city_name: '',
            subdistrict_name: '',
            village_id:'',
            village_name: '',
            address: '',
            latitude: '',
            longitude: '',
            ktp_url: '',
            education: '',
            education_jurusan: '',
            education_instansi: '',
            education_start_date: '',
            education_end_date: '',
            education_nilai_akhir: '',
            education_lampiran_url: '',
            status: '',
            kelas_id: [],
            mapel_id: [],
            lampiran_json: []
          },
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },

          category_jabatan: '',
          
          upload: {
            image: '',
            ktp_url: null,
            galery_array: null,
            document: '',
            image_lampiran: null,
            lampiran: null
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
          jabatan: [],
          category: [],
          mapel: [],
          kelas: [],
  
          process: {
            load: false,
            image: false,
            form: false,
            ktp_url: false,
            galery_array: false,
            document: false,
            image_lampiran: false,
            lampiran: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue'),
        uploaddoc: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      },
      watch: {
        'upload.image_lampiran': {
        handler: function () {
          if (this.upload.image_lampiran) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image_lampiran = this.upload.image_lampiran.process

            if (!this.process.image_lampiran) {
              this.form.lampiran_json.push({
                title: '',
                url: this.upload.image_lampiran.fileuri,
                type: 'image'
              })

              this.upload.image_lampiran = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.lampiran) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.lampiran = this.upload.lampiran.process
            
            if (!this.process.lampiran) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.lampiran.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.form.lampiran_json.push({
                title: '',
                url: this.upload.lampiran.fileuri,
                type: extension && extension[1]
              })

              this.upload.lampiran = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.ktp_url': {
          handler: function () {
            if (this.upload.ktp_url) {
              this.process.ktp_url = this.upload.ktp_url.process
  
              if (!this.process.ktp_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ktp_url = this.upload.ktp_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.galery_array': {
          handler: function () {
            if (this.upload.galery_array) {
              this.process.galery_array = this.upload.galery_array.process
  
              if (!this.process.galery_array) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.galery_array.push({
                  galery_url: this.upload.galery_array.fileuri,
                  galery_desc: ''
                })
  
                // this.save_image()
  
                this.upload.galery_array = null
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.f.rab_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                this.form.education_lampiran_url = this.upload.document.fileuri

                this.upload.document = null

                // this.f.rab_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchProv()
        this.fetchSchool()
        this.fetchCategory()
        this.fetchJabatan()
        this.fetchKelas()
        this.fetchMapel()
        this.fetchDetail()
      },
      methods: {
        async fetchDetail() {
          this.process.load = true
         let params = {
          id: this.$route.params.id,
          school_id: this.$route.params.school_id
        }
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/master/detail' : 'pegawai/detail'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.form = res.results.data
            this.form.tgl_lahir_date = moment(this.form.tgl_lahir).format('YYYY-MM-DD')
            this.form.jabatan_tmt = moment(this.form.jabatan_tmt).format('YYYY-MM-DD')
            this.form.education_start_date = moment(this.form.education_start_date).format('YYYY-MM-DD')
            this.form.education_end_date = moment(this.form.education_end_date).format('YYYY-MM-DD')
            this.form.lampiran_json = JSON.parse(this.form.lampiran_json)

            this.form.mobile_phone_number = res.results.data.mobile_phone_number.replace('62', '')

            this.center = {
              lat: res.results.data.latitude*1,
              lng: res.results.data.longitude*1
            }
            this.fetchCity(res.results.data.province_id)
            this.fetchSub(res.results.data.city_id)
            this.fetchVillage(res.results.data.subdistrict_id)
            this.fetchJabatan()
          }
        })
          this.process.load = false
      },
        async fetchSchool() {

          let params = {
          limit: 10000000000000
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.school = res.results.data
          }
        })
      },
      async fetchCategory() {

         let params = {
          limit: 10000000000000,
          school_id: this.filter.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/category/data' : 'pegawai_category/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },

      async fetchJabatan() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/jabatan/data' : 'jabatan/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.jabatan = res.results.data
          }
        })
      },

      async fetchKelas() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/kelas/data' : 'kelas/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.kelas = res.results.data
          }
        })
      },

      async fetchMapel() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/mapel/data' : 'mapel/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.mapel = res.results.data
          }
        })
      },
        async fetchProv() {
  
           let params = {
            limit: 10000000000000
          }
  
  
          await get(`ref/provinsi`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.province = res.results.data
            }
          })
        },
  
        changeProvince() {
          this.form.city_id = ''
          this.form.city_name = ''
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.province.map(obj => {
            if (obj.id === this.form.province_id) {
              id = obj.id
              this.form.province_name = obj.name
            }
          })
          this.fetchCity(id)
        },
  
        async fetchCity(id) {
  
           let params = {
            limit: 10000000000000,
            province_id: id
          }
  
          await get(`ref/kota`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.city = res.results.data
            }
          })
        },
  
        changeCity() {
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.city.map(obj => {
            if (obj.id === this.form.city_id) {
              id = obj.id
              this.form.city_name = obj.name
            }
          })
          this.fetchSub(id)
        },
  
        async fetchSub(id) {
  
           let params = {
            limit: 10000000000000,
            city_id: id
          }
  
          await get(`ref/kecamatan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.subdistrict = res.results.data
            }
          })
        },
  
        changeSub() {
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.subdistrict.map(obj => {
            if (obj.id === this.form.subdistrict_id) {
              id = obj.id
              this.form.subdistrict_name = obj.name
            }
          })
          this.fetchVillage(id)
        },
  
        async fetchVillage(id) {
  
           let params = {
            limit: 10000000000000,
            subdistrict_id: id
          }
  
          await get(`ref/kelurahan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.village = res.results.data
            }
          })
        },
  
        setPlace(place) {
          this.place = place
          this.center = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          
          }
            // this.initMap()
          this.form.latitude = this.place.geometry.location.lat()
          this.form.longitude = this.place.geometry.location.lng()
        },
        getGeoLocation() {
          if (this.form.id === '') {
            navigator.geolocation.getCurrentPosition(position => {
              this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            })
          } else {
            this.center = {
              lat: this.form.latitude,
              lng: this.form.longitude
            }
          }
        },
        updatePlace(location) {
          this.center = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng()
          }
  
          this.form.latitude = location.latLng.lat()
          this.form.longitude = location.latLng.lng()
        },
  
        async toNextStep  () {
          this.message.error = ''
          this.$refs.form.validate().then(success => {
            if (success) {
              this.step_index = this.step_index + 1
            if (this.$refs.form) this.$refs.form.reset()
            }
          })
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true

            let form = {
              ...this.form,
              lampiran_json: JSON.stringify(this.form.lampiran_json),
              mobile_phone_number: `62${this.form.mobile_phone_number}`
            }
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/master/add' : 'pegawai/master/update' : this.form.id === '' ? 'pegawai/add' : 'pegawai/update'
  
            // SAVE TO REST API
            await post(url, {
              // data: {
              //   id: this.form.id,
              //   school_id: this.filter.school_id,
              //   category_id: this.form.category_id,
              //   nip: this.form.nip,
              //   name: this.form.name,
              //   email: this.form.email,
              //   gender: this.gender,
              //   tempat_lahir: this.form.tempat_lahir,
              //   tgl_lahir_date: this.form.tgl_lahir_date,
              //   jabatan_id: this.form.jabatan_id,
              //   jabatan_name: this.form.jabatan_name,
              //   golongan: this.form.golongan,
              //   image_url: this.form.image_url,
              //   mobile_phone_number: this.form.mobile_phone_number,
              //   jabatan_tmt: this.form.jabatan_tmt,

              //   nik: this.form.nik,
              //   province_id: this.form.province_id,
              //   city_id: this.form.city_id,
              //   subdistrict_id: this.form.subdistrict_id,
              //   province_name: this.form.province_name,
              //   city_name: this.form.city_name,
              //   subdistrict_name: this.form.subdistrict_name,
              //   village_id: this.form.village_id,
              //   village_name: this.form.village_name,
              //   address: this.form.address,
              //   latitude: this.form.latitude,
              //   longitude: this.form.longitude,
              //   ktp_url: this.form.ktp_url,
              //   education: this.form.education,
              //   education_jurusan: this.form.education_jurusan,
              //   education_instansi: this.form.education_instansi,
              //   waktu_tempuh: this.form.waktu_tempuh,
              //   education_nilai_akhir: this.form.education_nilai_akhir,
              //   education_lampiran_url: this.form.education_lampiran_url,
              //   status: this.form.status,
              //   kelas_id: this.form.kelas_id,
              //   mapel_id: this.form.mapel_id,
              //   lampiran: this.form.lampiran
                
              // }
              data: form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/manajemen-akademik/data-pengguna/data-guru-pegawai' })
  
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
      },
      created () {
      }
    }
  </script>